<template>
  <app-loading-section :loading="isLoading" :count="notifications.length" class="notification_section">
    <template v-slot:message>
      <p class="hint-text">{{ emptyMessage }}</p>
    </template>

    <div class="flex flex-end mb-100">
      <button-link class="mr-100" @click="reloadNotifications">Reload</button-link>
      <button-link @click="deleteAllNotifications">Clear {{ total }} Notifications</button-link>
    </div>

    <div style="min-height: 440px">
      <notification-item
        v-for="(notification, index) in notifications"
        :key="index"
        :notification="notification"
        @deleted="deletedOneNotification"
      ></notification-item>
    </div>

    <b-pagination
      class="mt-100"
      v-model="currentPage"
      :total="total"
      :per-page="perPage"
      order="is-right"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      @change="getNotifications"
    />
  </app-loading-section>
</template>

<script>
import NotificationItem from "./NotificationItem";
import api from "../../../api";
import {ENUMS} from "../../../services/enums";

export default {
  name: "NotificationSection",
  components: {NotificationItem},
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      notifications: [],
      currentPage: 1,
      total: 0,
      perPage: 10,
    }
  },
  created() {
    this.getNotifications()
  },
  computed: {
    emptyMessage() {
      const category = this.category.value;
      const categoryEnum = ENUMS.NotificationCategoryEnum;

      if(category === categoryEnum.Mentions.value) return 'You do not have any mentions'
      if(category === categoryEnum.Tasks.value) return 'You do not have task mentions'
      if(category === categoryEnum.Appointments.value) return 'You do not have appointment mentions'
      if(category === categoryEnum.Leads.value) return 'You do not have lead mentions'
      if(category === categoryEnum.Comms.value) return 'You do not have comm mentions'
      if(category === categoryEnum.Profile.value) return 'You do not have profile mentions'
      if(category === categoryEnum.Errors.value) return 'You do not have error mentions'
      return 'There are no notifications'
    },
    categoryLabel() {
      return this.category.label
    }
  },
  methods: {
    getNotifications(newPage = null) {
      this.isLoading = true;

      if(newPage !== null) this.currentPage = newPage

      return api.notifications.allForCategory(this.category.value, `page=${this.currentPage}`).then(paginatedNotifications => {
        const meta = paginatedNotifications.data.meta;

        this.notifications = paginatedNotifications.data.data;
        this.currentPage = meta.current_page;
        this.total = meta.total;
        this.perPage = meta.per_page;
      }).finally(() => this.isLoading = false);
    },
    reloadNotifications() {
      this.$emit('reset')
      this.getNotifications()
    },
    deletedOneNotification() {
      // Need to reset the currentPage if the item deleted is the last one on the page

      // calc the number of items to remove from total to see how many on the current page
      const numberToRemove = (this.currentPage - 1) * this.perPage
      const leftOnCurrentPageBeforeDelete = this.total - numberToRemove

      // switch to previous page if there was only one item before deleting the item
      if(this.currentPage > 1 && leftOnCurrentPageBeforeDelete === 1) {
        this.currentPage = this.currentPage - 1;
      }

      // Reload the notifications no matter what
      this.reloadNotifications()
    },
    deleteAllNotifications() {
      return api.notifications.deleteAllForCategory(this.category.value).then(() => {
        this.reloadNotifications()

        this.$buefy.toast.open({
          message: "Notifications have been deleted",
          type: 'is-success'
        });
      });
    },
  },
}
</script>

<style scoped>
.notification_section {
  min-height: 530px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
